<template>
  <div class="modal-card" style="width: auto">
    <section class="modal-card-body p-lg">
      <form @submit.prevent="onSubmit">
        <div class="title is-5">Вход</div>
        <b-field label="Пользователь">
          <b-input type="email" v-model="email" icon="account" required></b-input>
        </b-field>
        <b-field label="Пароль">
          <b-input type="password" v-model="password" password-reveal icon="key" required></b-input>
        </b-field>
        <div v-if="error" class="warning has-text-danger">{{ errorMsg }}</div>
        <b-button type="is-primary" native-type="submit" :loading="loading" :disabled="loading">Войти</b-button>
      </form>
    </section>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';

export default {
  name: 'LoginModal',
  data() {
    return {
      loading: false,
      error: false,
      email: '',
      password: '',
      errorMsg: 'Неправильный логин или пароль'
    };
  },
  methods: {
    ...mapActions(['login']),
    onSubmit() {
      this.loading = true;
      this.error = false;
      const formData = {
        email: this.email,
        password: this.password
      };
      this.login(formData)
        .then(() => {
          this.loading = false;
          this.$emit('close');
        })
        .catch(err => {
          console.log(err);
          this.loading = false;
          this.error = true;
        });
    }
  },
  computed: {
    ...mapGetters['isAuth']
  }
};
</script>

<style scoped>
.demo-data {
  margin: 1rem 0;
  display: block;
}
.warning {
  margin: 0.5rem 0;
}
</style>
